"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Option", {
    enumerable: true,
    get: function() {
        return Option;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useOption = require("./useOption");
const _renderOption = require("./renderOption");
const _useOptionStylesstyles = require("./useOptionStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Option = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useOption.useOption_unstable)(props, ref);
    (0, _useOptionStylesstyles.useOptionStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useOptionStyles_unstable')(state);
    return (0, _renderOption.renderOption_unstable)(state);
});
Option.displayName = 'Option';
